import { Core } from "@faire/design-tokens";
import { OwFFormErrors } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/consts";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { path as viewEmailPath } from "@faire/web-api--source/endpoints/www/api/email/view/outgoingEmailToken/html/get";
import React, { FC } from "react";

interface IOwFFormProps {
  errors: OwFFormErrors;
}

export const OwFErrorMessage: FC<IOwFFormProps> = ({ errors }) => {
  if (!errors.message) {
    return null;
  }

  return (
    <>
      <Spacer height="1x" />
      <Typography align="center" color={Core.text.critical}>
        {errors.message}
      </Typography>
      <Spacer height="1x" />
      {errors.emailToken ? (
        <Typography align="center">
          <Button
            variant="tertiary"
            linkTo={viewEmailPath(errors.emailToken)}
            target="_blank"
          >
            <StrictLocalMsg
              defaultMessage="View Email"
              description={{
                text: "User click on this link to open an email in a new browser tab",
              }}
            />
          </Button>
        </Typography>
      ) : null}
    </>
  );
};
